/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import Header from './components/presentational/Header';

import CalendarContent from './components/presentational/CalendarContent';

const PageWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.viewType !== 'weekView' ? '49px' : '0px')};
  padding-top: ${(props) => (props.viewType === 'weekView' ? '49px' : '')};
  height: ${(props) => (props.viewType === 'weekView' ? '100%' : 'calc(100% - 49px)')};
  width: 100%;
  background: #F5F5F5;
`;

const IconSideBarAndContentWrapper = styled('div')`
  display: flex;
  position: relative; 
  height: ${(props) => (props.viewType === 'weekView'
    ? '100%'
    : props.headerHeight
      ? `calc(100% - ${props.headerHeight}px)`
      : 'calc(100% - 61.5px)')};
  padding-top: ${(props) => (props.viewType === 'weekView' ? `${props.headerHeight}px` : '')};
  ${(props) => props.viewType === 'weekView' && 'min-width: fit-content;'}
`;

const CalendarLayout = () => {
  const headerHeight = useSelector((state) => state.calendar.data.headerHeight);

  const viewType = useSelector((state) => state.calendar.data.viewType);
  return (
    <PageWrapper viewType={viewType}>
      <Header />
      <IconSideBarAndContentWrapper headerHeight={headerHeight} viewType={viewType}>
        <CalendarContent />
      </IconSideBarAndContentWrapper>
    </PageWrapper>
  );
};

export default CalendarLayout;
